export default {"src":"/_next/static/media/money-wings-own.841d3f81.svg","height":100,"width":100};